"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DropdownToggle = _interopRequireDefault(require("reactstrap/lib/DropdownToggle"));

var _Button = _interopRequireDefault(require("reactstrap/lib/Button"));

var _icon = _interopRequireDefault(require("../icon/icon"));

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react/jsx-fragments */
var DropdownTrigger = function DropdownTrigger(props) {
  var type = props.type,
      disabled = props.disabled,
      disabledTrigger = props.disabledTrigger,
      label = props.label,
      split = props.split,
      disabledMain = props.disabledMain,
      onClick = props.onClick,
      icon = props.icon,
      ariaLabel = props.ariaLabel;

  if (type === "tertiary" || type === "link") {
    return /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
      caret: true,
      className: "oui-dt-type-".concat(type),
      disabled: disabled || disabledTrigger
    }, label, "\xA0");
  }

  if (type === "icon" && /*#__PURE__*/_react["default"].isValidElement(icon)) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
      tag: "span",
      disabled: disabled || disabledMain
    }, /*#__PURE__*/_react["default"].cloneElement(icon, {
      clickable: true,
      disabled: disabled || disabledTrigger
    }));
  }

  return split ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    outline: type === "secondary",
    onClick: onClick,
    disabled: disabled || disabledMain
  }, label), /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
    caret: true,
    color: "primary",
    outline: type === "secondary",
    split: split,
    disabled: disabled || disabledTrigger
  })) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, icon ? /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
    tag: "div",
    className: "oui-icon-dropdown-trigger",
    disabled: disabled || disabledMain
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "primary",
    outline: type === "secondary",
    "aria-label": ariaLabel ? "".concat(ariaLabel, " dropdown") : "",
    onClick: onClick,
    disabled: disabled || disabledMain
  }, /*#__PURE__*/_react["default"].isValidElement(icon) ? icon : /*#__PURE__*/_react["default"].createElement(_icon["default"], (0, _extends2["default"])({
    muted: false
  }, icon)))) : /*#__PURE__*/_react["default"].createElement(_DropdownToggle["default"], {
    caret: true,
    color: "primary",
    outline: type === "secondary",
    disabled: disabled || disabledTrigger
  }, label, "\xA0"));
};

DropdownTrigger.propTypes = {
  type: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  disabledTrigger: _propTypes["default"].bool,
  disabledMain: _propTypes["default"].bool,
  label: _propTypes["default"].string,
  split: _propTypes["default"].bool,
  icon: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    size: _propTypes["default"].oneOf(["xs", "sm", "md", "lg"]),
    width: _propTypes["default"].string,
    height: _propTypes["default"].string,
    classes: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  }),
  onClick: _propTypes["default"].func,
  ariaLabel: _propTypes["default"].string
};
DropdownTrigger.defaultProps = {
  type: "primary",
  disabled: false,
  disabledTrigger: false,
  disabledMain: false,
  label: null,
  split: false,
  icon: null,
  onClick: null
};
DropdownTrigger.displayName = "OrionDropdownTrigger";
var _default = DropdownTrigger;
exports["default"] = _default;